module.exports = __webpack_public_path__ + "img/icon-button-find.be1e3b29.svg";